// @flow
import ScrollToTop from "./ScrollToTop";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Help from "../pages/Help";
import User from "../pages/User";
import Schedule from "../pages/Schedule/Schedule";
import MainTabNavigation from "../MainTabNavigation";
import React, { Suspense } from "react";
import Login from "../pages/Login";
import Admin from "../pages/Admin";
import { AuthCheck, SuspenseWithPerf } from "reactfire";
import BackdropLoading from "../components/BackdropLoading";
import PageViewLogger from "./PageViewLogger";
import SetUserId from "./SetUserId";
import TicketReservation from "../pages/TicketReservation/TicketReservation";
import TicketReservationSkeleton from "../pages/TicketReservation/TicketReservationSkeleton";
import Ticket from "../pages/Tickets/Ticket";
import PrivateRoute from "./PrivateRoute";
import GameAdmin from "../pages/GameAdmin/GameAdmin";
import Rankings from "../pages/Rankings/Rankings";
import TickerStream from "../pages/TickerStream";
import TickerAdmin from "../pages/TickerAdmin";

function MainRouter() {
  return (
    <Router>
      <ScrollToTop />
      <SuspenseWithPerf
        traceId="MainRouterSwitch"
        fallback={<BackdropLoading />}
      >
        <Switch>
          <Route path="/login">
            <Login />
          </Route>
          <Route path="/rankings">
            <Rankings />
          </Route>
          <Route path="/help">
            <Help />
          </Route>
          <PrivateRoute path="/admin/game/:gameId">
            <SuspenseWithPerf
              traceId="GameAdmin"
              fallback={<BackdropLoading />}
            >
              <GameAdmin />
            </SuspenseWithPerf>
          </PrivateRoute>
          <PrivateRoute path="/admin">
            <SuspenseWithPerf traceId="Admin" fallback={<BackdropLoading />}>
              <Admin />
            </SuspenseWithPerf>
          </PrivateRoute>
          <PrivateRoute path="/ticket-reservation/:gameId">
            <SuspenseWithPerf
              traceId="TicketReservation"
              fallback={<TicketReservationSkeleton />}
            >
              <TicketReservation />
            </SuspenseWithPerf>
          </PrivateRoute>
          <PrivateRoute path="/ticket/:gameId">
            <Ticket />
          </PrivateRoute>
          <PrivateRoute path="/profile">
            <User />
          </PrivateRoute>
          <PrivateRoute path="/ticker-admin/:gameId">
            <Suspense>
              <TickerAdmin />
            </Suspense>
          </PrivateRoute>
          <Route path="/ticker-stream/:gameId">
            <Suspense>
              <TickerStream />
            </Suspense>
          </Route>
          <Route path="/">
            <Schedule />
          </Route>
        </Switch>
        <SuspenseWithPerf traceId="SetUserId" fallback={undefined}>
          <AuthCheck fallback={undefined}>
            <SetUserId />
          </AuthCheck>
        </SuspenseWithPerf>
        <PageViewLogger />
      </SuspenseWithPerf>
      <MainTabNavigation />
    </Router>
  );
}

export default MainRouter;
